import script from "./market-tab-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./market-tab-item.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__